import { connect } from "react-redux";
import PmSoftwareSities from "./List";
import { bindActionCreators } from "redux";
import {
    pmSoftwareMaintenanceSites,
    fetchMonth,
    PMSoftwareDownloadList,
    // uploadPmList,
    getPmSoftwareFilterDropDown,
} from "services/redux/maintenance/pmSities/action";

const mapStateToProps = (state) => ({
    pmSoftwareSitesDetails: state.pmSitiesReducer.pmSoftwareSitesDetails,
    maintenanceMonth: state.pmSitiesReducer.maintenanceMonth,
    pmSoftwareReportListDownload: state.pmSitiesReducer.pmSoftwareReportListDownload,
    pmSoftwareFilterResponse: state.pmSitiesReducer.pmSoftwareFilterResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            pmSoftwareMaintenanceSites,
            PMSoftwareDownloadList,
            fetchMonth,
            getPmSoftwareFilterDropDown
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PmSoftwareSities);
